// Product page product image mobile slider start
$(document).ready(function () {
  $(".main_image").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    slide: "li",
    arrows: !1,
    fade: !0,
    asNavFor: ".thumbnail_image",
  }),
    $(".thumbnail_image").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: ".main_image",
      arrows: !1,
      dots: !1,
      slide: "li",
      centerMode: !1,
      focusOnSelect: !0,
      speed: 1500,
      infinite: !0,
      autoplay: !0,
      autoplaySpeed: 2e3,
    });
});
// Product page product image mobile slider end

// New Swiper Reels videos
